import useMuiTableBuilderV2 from 'hooks/useMuiTableBuilderV2';
import { useMemo } from 'react';
import { FetchDataOverviewByDataTypeState } from './DataTypeUpdatesOverview';
import { getTableConfig } from './tableConfig';
import { useMainListBuilder } from './helpers/useMainListBuilder';

const tableConfig = getTableConfig({});

const DataTypeUpdatesOverviewTable = ({
  dataOverviewByDataTypeHash,
  isLoading,
}: {
  dataOverviewByDataTypeHash: FetchDataOverviewByDataTypeState['dataOverviewByDataTypeHash'];
  isLoading: boolean;
}) => {
  const mainListBuilder = useMainListBuilder({ dataOverviewByDataTypeHash });

  const mainList = useMemo(() => mainListBuilder(), [mainListBuilder]);

  const _customRowProps = useMemo(() => ({}), []);

  const { TableComponent } = useMuiTableBuilderV2({
    ...tableConfig,
    mainList,
    isLoading,
    _customRowProps,
    tableMaxHeight: '16rem',
  });

  return TableComponent;
};

export default DataTypeUpdatesOverviewTable;
